const localHost = 'http://localhost:8000';

export const currentUrl =
  (process.env.REACT_APP_BACKEND_URL || '').trim() || localHost;
